/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 09:32:13
 * @LastEditors: linxi
 * @LastEditTime: 2024-12-25 14:44:11
 */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import {
  DateRangeType,
  DateSelect as DateSelectOne,
  getDateRange,
  RecentTime, RecentTimePotion,
} from '../../../compnents/date/TimeSelect'
import { replaceMakeDetailParams, SupplierListResponse } from '../../../services/OReplaceMake'
import moment from 'moment'
import styles from './order.module.css'
import { getSupplierList } from '../OReplaceMakeSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { selectChainType } from '../../../app/applicationSlice'

export const Query = (props: {
  loading?: any
  chainList?: Array<any>
  onValueChange: (queries: replaceMakeDetailParams) => void
  onExport: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const chainType = useSelector(selectChainType)

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [supplierOptions, setSupplierOptions] = useState<
    Array<SupplierListResponse>
  >([])

  const recipeStatusOptions = [
    {
      value: -1,
      label: '全部',
    },
    {
      value: 0,
      label: '未上传',
    },
    {
      value: 1,
      label: '已上传',
    },
    {
      value: 3,
      label: '已取消',
    },
  ]

  const machiningTypeOptions = [
    {
      value: -1,
      label: '全部',
    },
    {
      value: 0,
      label: '委外代煎颗粒剂',
    },
    {
      value: 1,
      label: '委外代煎袋装液体',
    },
    {
      value: 2,
      label: '委外外配药材',
    },
    {
      value: 3,
      label: '委外膏方代煎',
    },
  ]

  useEffect(() => {
    dispatch(getSupplierList())
      .then(unwrapResult)
      .then((res: Array<SupplierListResponse>) => {
        setSupplierOptions(res)
      })
      form.setFieldsValue({
        mergeFlag: 0,
      })
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(v) => {     
        if(!v?.pullTimeHead && v?.TimeRange==6){
          return
        }   
        const time = {
          pullTimeHead: null,
          pullTimeTail: null,
          startTime: v?.pullTimeHead
            ? moment(v.pullTimeHead).format('YYYY-MM-DD HH:mm:ss')
            :  moment(head).format('YYYY-MM-DD HH:mm:ss'),
          endTime: v?.pullTimeTail
            ? moment(v.pullTimeTail).format('YYYY-MM-DD HH:mm:ss')
            :  moment(tail).format('YYYY-MM-DD HH:mm:ss'),
        }
        props.onValueChange({ ...v, ...time })
      }}
      style={{ paddingBottom: '10px' }}
    >
      <Row>
        <Space style={{ flex: 1 }}>
          <Form.Item name='keyWord' noStyle>
            <Input
              size='middle'
              placeholder='药品名称/助记码'
              // onChange={form.submit}
              allowClear
              style={{ width: 180 }}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          {props.chainList?.length ? (
            <Form.Item name='chainId' noStyle>
              <Select
                allowClear
                placeholder='机构名称'
                onChange={form.submit}
                dropdownClassName={styles.selectDropdown}
                style={{ minWidth: 150, maxWidth: 410 }}
              >
                {props.chainList?.map((v: any) => (
                  <Select.Option key={v?.id} value={v?.id?.toString()}>
                    {v?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : null}
          <Form.Item name='supplierId' noStyle>
            <Select allowClear placeholder='代煎饮片厂' onChange={form.submit} style={{ width: 120 }}>
              {supplierOptions.length &&
                supplierOptions?.map((c) => (
                  <Select.Option key={c.name} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          {chainType != 3 && (
            <Form.Item name='machiningType' noStyle>
              <Select
                allowClear
                placeholder='代煎类别'
                onChange={form.submit}
                dropdownClassName={styles.select}
                style={{ width: 120 }}
              >
                {machiningTypeOptions.map((c) => (
                  <Select.Option key={c.label} value={c.value}>
                    代煎类别-{c.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {chainType != 3 && (
            <Form.Item name='recipeStatus' noStyle>
              <Select
                allowClear
                placeholder='上传状态'
                onChange={form.submit}
                dropdownClassName={styles.select}
                style={{ width: 120 }}
              >
                {recipeStatusOptions.map((c) => (
                  <Select.Option key={c.label} value={c.value}>
                    上传状态-{c.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='mergeFlag' noStyle>
            <Select
              placeholder='合并同名'
              allowClear
              onChange={form.submit}
              dropdownClassName={styles.select}
            >
              <Select.Option value={0}>合并-否</Select.Option>
              <Select.Option value={1}>合并-是</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item noStyle>
            <DateSelectOne
              width={340}
              showTime={true}
              placeholder='上传时间'
              options={RecentTimePotion}
              initialValue={DateRangeType.Today}
              style={{ width: 120 }}
              labelPrefix=''
              onChange={form.submit}
              namePrefix='pullTime'
            />
          </Form.Item>
          <Button htmlType='submit' type='primary' loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space>
          <Button type='primary' onClick={() => props.onExport()}>
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
